<script setup lang="ts">
// The six options and their values must stay in sync with app/Enums/FeedbackRating.php
// (the backing value *is* the Italian label, so it doubles as what we display).
const ratings = [
    'decisamente inutile',
    'inutile',
    'abbastanza inutile',
    'abbastanza utile',
    'utile',
    'decisamente utile',
]

const model = defineModel<string | null>()
</script>

<template>
    <div class="col items-stretch gap-3">
        <label v-for="rating in ratings" :key="rating" class="row gap-2 items-center cursor-pointer">
            <input type="radio" name="feedback-rating" :value="rating" v-model="model">
            <span class="capitalize">{{ rating }}</span>
        </label>
    </div>
</template>

<style scoped>
@reference 'tailwindcss';
@reference '#app.css';

input {
    /* Nuke the default browser style */
    -webkit-appearance: none;
    @apply appearance-none m-0;
}

input[type="radio"] {
    @apply size-4.5 border border-blue-700 rounded-full;

    @variant checked {
        @apply bg-blue-700;
    }
}
</style>
